import _ from "../../../../lib/lodash.custom.min";

/*
 * 状態を保持するためのオブジェクトを生成するクラス
 * 状態がsetされたらeventHub(on/triggerを持つオブジェクト)を介してイベントをtriggerする
 * イベント名は var event = getEvents(); event("property_name")で取得する
 * ex)  
 * 	 var $ev = jQuery(document);
 *   var state = new State({}, $ev);
 *   var event = state.getEvents();
 *
 *   $ev.on(event(propertyName), listener);
 *   state.set({propertyName: value});  // listenerが呼ばれる
 *
 */
export default class State {
	constructor(initState, eventHub, eventPrefix) {
		Object.assign(this, initState);
		this._ev = eventHub;
		this._eventPrefix = eventPrefix || "forcia-change-state.";
	}

	set(obj, bool) {
		_.each(obj, function(val, key) {
			this[key] = val;
		}.bind(this));

		this._ev.trigger(this._eventPrefix + "BEFORE_ALL");
		_.each(obj, function(val, key) {
			this._ev.trigger(this._eventPrefix + key);
		}.bind(this));
		this._ev.trigger(this._eventPrefix + "AFTER_ALL");
	}

	getEvents() {
		return (...args) => {
			// args: 'a', 'b', 'c'
			// return: 'prefix-a prefix-b prefix-c'
			return _.map(args, (key) => {
				return this._eventPrefix + key;
			}).join(" ");

		};
	}
}



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/modules/state.js